import React from 'react';
import './whatsapp-floating.css';

const WhatsAppFloating = () => {
    return (
        <a 
            href="https://wa.me/5511930766388" 
            target="_blank" 
            rel="noopener noreferrer"
            className="whatsapp-floating-btn"
            title="Contate-nos pelo WhatsApp"
        >
            <i className="fa fa-whatsapp"></i>
        </a>
    );
};

export default WhatsAppFloating;
